/**
 * An uploaded file's address, as the browser can load it.
 *
 * Without a CDN the backend stores an upload's URL as a path on itself:
 * "/uploads/avatars/x.png" on local disk (the API's /uploads mount), or
 * "/api/uploads/avatars/x.png" in S3, which the API answers with a signed
 * link to the private bucket. The
 * frontend runs on another host, so that path has to be read against the
 * API's address; left alone, the browser asks the frontend's host and gets
 * nothing. Full URLs (a CDN, S3, an external link) and data/blob URLs pass
 * through unchanged; so do empty values.
 */
const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8000').replace(/\/+$/, '')

export const mediaUrl = <T extends string | null | undefined>(url: T): T | string =>
  typeof url === 'string' && (url.startsWith('/uploads/') || url.startsWith('/api/uploads/')) ? `${API_URL}${url}` : url
